import * as React from 'react';
import {ThumbnailUploadPreview} from "./ThumbnailUploadPreview";
import {ThumbnailDoneIcon} from "./ThumbnailDoneIcon";
import {ThumbnailUploadBtnActions} from "./ThumbnailUploadBtnActions";
import Icons from "../../Icons";
import {getShopInfosInStorage} from "../../../cart/ShopInfos";
import {getShopRefInStorage} from "../../MonCompteAction";
import {cmjnData} from "./UpdateCmjn";
import { ModalRemoveBackground } from './ModalRemoveBackground';

interface ThumbnailUploadContainerProps {
  activateCheckImageUsage: boolean;
  data: any;
  onDeleteFile: any;
  resetCustomOptions: any;
  handleChangeColors: any;
  submitHandleChangeColors: any;
  changeOptionEvent: any;
  getPreview: any;
  updateDimensions: any;
  onDownloadFile: any;
  onChangeOutlineProcessing: any;
  nonConforme: boolean;
  onApplyOutline: (applyOutline: boolean, colorOutline: string) => void;
  onRollback: () => void;
  onCheckImageUsage: () => Promise<boolean>;
  dimIsModified: boolean;
  onUpdateCmjn?: (idCaddies: string, cmjnData: cmjnData) => void;
  backgroundCanBeRemovedConditions: boolean;
}

export const ThumbnailUploadContainer = (props: ThumbnailUploadContainerProps) => {
  const strLargeur = props.data.dimensions && props.data.dimensions.largeur && props.data.dimensions.largeur > 0 ? props.data.dimensions.largeur.toFixed(2).replace('.', ',') : null;
  const strHauteur = props.data.dimensions && props.data.dimensions.hauteur &&  props.data.dimensions.hauteur > 0 ? props.data.dimensions.hauteur.toFixed(2).replace('.', ',') : null;

  const isDT = getShopRefInStorage() === 'DT';
  let bgColor = props.data.cmjnCs?.isPersonnalise ? `#${props.data.cmjnCs.hexadecimal}` : `#${props.data.color.code1}`;
  if(isDT) {
    bgColor = 'transparent';
  }

  const reuploadAdminBatValide = (props.data.isInternalUserAdmin && !props.data.customerView) &&
    props.data.order.validation_bat == '2' && props.data.order.confirmationFichier == '1' &&
    (props.data.order.StatutCommande == '5' || props.data.order.StatutCommande == '6' || props.data.order.StatutCommande == '7');
  const reuploadBtnAdminBatValide = reuploadAdminBatValide && props.data.originalFileInfos?.statutLigneMarquageId === 2;
  const modificationsEnabled = ((props.data.order.confirmationFichier == '0' || (props.data.isInternalUser && !props.data.customerView) ) && props.data.order.validation_bat == '0') || reuploadBtnAdminBatValide;
  const onlyDownload = (props.data.isInternalUser && !props.data.customerView && isDT) || (props.data.isInternalUser && !props.data.customerView && props.data.order.confirmationFichier == 1 && props.data.order.validation_bat > 0) && !reuploadBtnAdminBatValide;
  const canViewFeatures = ((props.data.order.StatutCommande == '5' && props.data.isInternalUser && !props.data.customerView) || props.data.order.confirmationFichier == 0) || reuploadBtnAdminBatValide;
  const nonConforme = props.nonConforme;

  if (props.data.fileRegisteredOriginalName && props.data.textAlert === '' &&
    !props.data.displayChargement  && props.data.displayContainerButtons === 'none') {
    return (
      <div id={'fileSelected-' + props.data.identifier}
           className="py-2 position-relative d-flex justify-content-end flex-wrap flex-md-nowrap">
        <div className="d-flex flex-row align-items-center order-md-2">
          <div className={'d-flex'}>
            <div className={'position-relative d-flex flex-column align-items-center justify-content-between mr-3' +
              ' cursor-pointer containerThumbnail'}
                 style={{ outline: '1px solid #dee2e6', width: '120px', minHeight: '120px', backgroundColor: bgColor}}>
              {(props.data.bat && props.data.bat.filename) &&
                <ThumbnailUploadPreview bgColor={bgColor} marquageId={parseInt(props.data.marquage.id,10)}  fileRegisteredSize={props.data.fileRegisteredSize} fileRegisteredOriginalName={props.data.fileRegisteredOriginalName} fileRegisteredId={(props.data.isInternalUser && !props.data.customerView) ? props.data.fileRegisteredId : null} fromGallery={parseInt(props.data.fromGallery,10) === 1} BatFilename={props.data.bat.filename} pathLoadBat={props.data.pathLoadBat}  />
              }
              <ModalRemoveBackground identifier={props.data.identifier} backgroundCanBeRemovedConditions={props.backgroundCanBeRemovedConditions} changeOptionEvent={props.changeOptionEvent}/>
              <ThumbnailDoneIcon identifier={props.data.identifier} originalFileInfos={props.data.originalFileInfos}/>
              {(parseInt(props.data.fromGallery,10) === 1 && props.data.isInternalUser && !props.data.customerView) &&
                <div title={`Sélectionnée depuis votre galerie d'images\n${props.data.oldCmdFromGallery ? `Commande initiale: ${props.data.oldCmdFromGallery}` : ''}`} className="cursor-help text-info px-1 bg-info white text-center w-100">
                  <span className="pl-1">GALERIE</span>
                </div>
              }
              {strLargeur && strHauteur && props.data.bat && props.data.pathLoadBat &&
                <div className={'bg-white black text-center'}  style={{ borderTop: '1px solid #dee2e6', width: '100%' }}><span className={'px-1'}>{strLargeur}cm x {strHauteur}cm</span>
                  {(props.dimIsModified && props.data.isInternalUser && !props.data.customerView && getShopInfosInStorage().Ref !== 'DT') &&
                    <div title={'Le visuel a été réduit ou agrandi'} className={'cursor-help small text-info '}>
                      <Icons icon="warning" size={12} className={'text-info mr-1'} />
                      Dimensions modifiées</div>
                  }
                </div>
              }
              <div className={'d-flex identifiantsFichiersContainer p-1 justify-content-between align-items-center'}>
              {(props.data.isInternalUser && !props.data.customerView && props.data.originalFileInfos && props.data.originalFileInfos.original_file_id) &&
                <div title={`Identifiant du fichier client : ${props.data.originalFileInfos.original_file_id}`} className={'cursor-help text-info px-1 bg-info white text-center signatureFileClient signatureFileOrigin '}>{props.data.originalFileInfos.original_file_id}</div>
              }
              </div>
            </div>
              <ThumbnailUploadBtnActions
                canViewFeatures={canViewFeatures}
                onChangeOutlineProcessing={props.onChangeOutlineProcessing}
                onRollback={props.onRollback}
                resetCustomOptions={props.resetCustomOptions}
                changeOptionEvent={props.changeOptionEvent}
                data={props.data}
                handleChangeColors={props.handleChangeColors}
                submitHandleChangeColors={props.submitHandleChangeColors}
                getPreview={props.getPreview}
                onDownloadFile={props.onDownloadFile}
                updateDimensions={props.updateDimensions}
                activateCheckImageUsage={props.activateCheckImageUsage}
                canCheckImageUsage={props.data.canCheckImageUsage}
                modificationsEnabled={modificationsEnabled}
                onDeleteFile={props.onDeleteFile}
                onCheckImageUsage={props.onCheckImageUsage}
                canUpdateCmjn={props.data.canUpdateCmjn}
                canUpdateOutlineProcessing={props.data.canUpdateOutlineProcessing}
                canDownloadEmbroidery={props.data.canDownloadEmbroidery}
                onlyDownload={onlyDownload}
                nonConforme={nonConforme}
                onUpdateCmjn={props.onUpdateCmjn}
                onApplyOutline={props.onApplyOutline}
              />
            </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}
